import { useMutation, useQueryClient } from "@tanstack/react-query";
import { mutator } from "@/shared/api";
import { handleSuccess } from "@/shared/lib/success";
import { betaAccessRequestKeys } from "./queryKeys";
import type { CreateBetaAccessRequestPayload } from "../model/types";

export function useBetaAccessRequestAccept() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      mutator("POST", `/beta-access-requests/${id}/accept`, {}),
    onSuccess: (data) => {
      handleSuccess(data, { titleKey: "success.betaAccessRequest.accepted" });
      queryClient.invalidateQueries({
        queryKey: betaAccessRequestKeys.lists(),
      });
    },
  });
}

export function useBetaAccessRequestResend() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      mutator("POST", `/beta-access-requests/${id}/resend`, {}),
    onSuccess: (data) => {
      handleSuccess(data, { title: "Invite link sent" });
      queryClient.invalidateQueries({
        queryKey: betaAccessRequestKeys.lists(),
      });
    },
  });
}

export function useCreateBetaAccessRequest() {
  return useMutation({
    mutationFn: (payload: CreateBetaAccessRequestPayload) =>
      mutator("POST", "/beta-access-requests", payload),
  });
}
